import {
  Box,
  Collapse,
  Dialog,
  Table,
  TableCell,
  TableRow,
} from '@mui/material';
import styled from 'styled-components';

export const StyledTable = styled(Table)`
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.15);
  border-radius: 5px;
  width: 100%;
`;

export const TableBox = styled(Box)`
  width: 100%;
  max-width: 1524px;
`;

export const TableContainer = styled(Box)`
  display: flex;
  flex-direction: column;
`;

export const PaginationCell = styled(TableCell)`
  padding: 0 6px;
`;

export const StyledTableRow = styled(TableRow)<{ expanded: boolean }>`
  cursor: pointer;
  box-shadow: ${(props) =>
    props.expanded ? '0 4px 8px rgba(0, 0, 0, 0.1)' : 'none'};

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;

export const CollapseContentBox = styled(Collapse)`
  background-color: #f5f5f5;
`;

export const TableHeadCell = styled(TableCell)`
  padding: 0.75rem 0.5rem;
  position: relative;
  font-size: 0.9rem;
  font-weight: 600;
  vertical-align: middle;
  line-height: 1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:not(:last-child)::after {
    content: '';
    height: 28%;
    width: 2px;
    position: absolute;
    margin-left: 20px;
    right: 8px;
    top: 36%;
    bottom: 36%;
    background-color: #bdbdbd;
  }
`;

export const StyledCollapsedTableCell = styled(TableCell)`
  max-width: 300px;
  white-space: normal;
  word-wrap: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const StyledTableCell = styled(TableCell)`
  padding: 0.75rem 0.5rem;
  max-width: 300px;
  white-space: normal;
  word-wrap: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ActionsContainer = styled.div`
  display: flex;
  gap: 0.25rem;
  margin: 1rem 0;
  justify-self: center;
`;

export const CollapseHeader = styled(TableCell)`
  color: #666;
`;

export const StyledDialog = styled(Dialog)<{ align?: string }>`
  && .MuiDialog-paper {
    margin: 1rem 2rem;
    max-height: 99vh;
    align-self: ${(props) => (props.align ? props.align : `center`)};
  }

  && .MuiDialogTitle-root {
    padding: 0.65rem 1rem;
    font-weight: 600;
  }

  && .MuiDialogContent-root {
    padding: 1rem 1.5rem;
    min-width: 600px;
    max-width: 100%;

    && .MuiTextField-root {
      width: 100%;
      padding: 5rem;
    }
  }
  && .MuiDialogActions-root {
    padding: 0.75rem 1.5rem;
  }
`;
